import cnameZones from "./cname-zones";
import createCutomHostname from "./create-custom-hostname";
import domains from "./domains";
import listCustomHostnames from "./list-custom-hostnames";
import lookupDomainsAvailability from "./lookup-domains-availability";
import pointingInstructions from "./pointing-instructions";
import pointingStatus from "./pointing-status";
import tlds from "./tlds";
import domainOwnershipVerificationStatus
  from "./domain-ownership-verification-status";

export default {
  cnameDnsZones: cnameZones.cnameDnsZones,
  createCustomHostname: createCutomHostname,
  domainAvailability: domains.domainAvailability,
  domainsList: domains.domainsList,
  listCustomHostnames: listCustomHostnames,
  lookupDomainsAvailability: lookupDomainsAvailability,
  pointingInstructions: pointingInstructions,
  pointingStatus: pointingStatus,
  tldsCollection: tlds.tldsCollection,
  domainOwnershipVerificationStatus: domainOwnershipVerificationStatus,
};
